module.exports = __webpack_public_path__ + "static/media/ri-digital-1.864c5105.png";